export class MockDateAdapter {
  setLocale = jasmine.createSpy('setLocale');
}
